import Link from "next/link"

export function ResoltoMark({ size = 28 }: { size?: number }) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      className="brand-mark"
    >
      <rect x="1" y="1" width="26" height="26" rx="7" fill="currentColor" />
      <path
        d="M8 20V8h6.2c3.25 0 5.2 1.62 5.2 4.33 0 1.78-.88 3.1-2.45 3.78L20.2 20h-3.65l-2.63-3.35h-2.7V20H8Zm3.22-6.05h2.75c1.4 0 2.18-.55 2.18-1.55 0-1.02-.78-1.57-2.18-1.57h-2.75v3.12Z"
        fill="var(--color-surface)"
      />
    </svg>
  )
}

export function ResoltoWordmark({
  href = "/",
  compact = false,
}: {
  href?: string
  compact?: boolean
}) {
  return (
    <Link href={href} className="wordmark" aria-label="Resolto home">
      <ResoltoMark />
      {!compact && <span>resolto</span>}
    </Link>
  )
}
